import { motion } from "framer-motion";
import { GALLERY } from "@/data/site";

export const Gallery = () => {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#2563eb]">
            Our Work
          </span>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight text-[#0f2452]">
            Real homes, real results
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            A look at recent cleaning jobs across Iqaluit — from grimy move-out
            kitchens to fresh, move-in ready spaces.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {GALLERY.map((g, i) => (
            <motion.div
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 0.97 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group relative overflow-hidden rounded-3xl border border-slate-200 shadow-sm aspect-[4/5]"
            >
              <img
                src={g.src}
                alt={g.label}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f2452]/80 via-transparent to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-5">
                <p className="font-display text-lg font-bold text-white">
                  {g.label}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
